import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {store, persistor} from "@Redux/store";
import { Provider } from "react-redux";
import {PersistGate} from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(document.getElementById("root"));
console.log = () => {};
console.warn = () => {};
console.error = () => {};
console.info = () => {};


// Render the app and run the check for old messages
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App/>
    </PersistGate>
  </Provider>,
);


reportWebVitals();
